/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useFormik } from "formik";

// @material-ui/core components
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  FormControlLabel,
  FormGroup,
  FormLabel,
  LinearProgress,
  TextField,
  Typography,
} from "@material-ui/core";

import makeStyles from "@material-ui/styles/makeStyles";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";

// @material-ui/lab components
import Tab from "@material-ui/core/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import Alert from "@material-ui/lab/Alert";

// Karsten
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import TransferListProfile from "components/List/TransferListProfile";
import TransferList from "components/List/TransferList";
import MaskAndValid from "utils/maskAndValid";
import Api from "lib/api/httpRequestHelper";
import UtilsFncs from "utils/UtilsFncs";
import {
  PROFILE_CANAL_OPTIONS,
  PROFILE_TIPO_PESSOA_OPTIONS,
} from "views/admin/constants/profile-options";

const useStyles = makeStyles({
  icon: {
    display: "flex",
    alignItems: "center",
  },
  message: {
    fontSize: "0.8rem",
  },
});

const filtraNaoVinculados = (items, vinculados, fieldKey) => {
  const naoVinculados = (items || []).filter(
    (field) =>
      !vinculados.some((vinculado) => vinculado[fieldKey] === field[fieldKey]),
  );
  return naoVinculados;
};

const checkNothingChanged = (
  selectedProfile,
  vinculados,
  notificacoesVinculadas,
  initialNotificationLinked,
  canais,
  tiposPessoa,
  initialCanais,
  initialTiposPessoa,
) => {
  return !(
    (vinculados &&
      !UtilsFncs.ArrayEquals(selectedProfile?.Menus, vinculados)) ||
    (notificacoesVinculadas &&
      !UtilsFncs.ArrayEquals(
        initialNotificationLinked,
        notificacoesVinculadas,
      )) ||
    !UtilsFncs.ArrayEquals(canais, initialCanais) ||
    !UtilsFncs.ArrayEquals(tiposPessoa, initialTiposPessoa)
  );
};

const toggleArrayValue = (values, value) => {
  if (values.includes(value)) {
    return values.filter((item) => item !== value);
  }

  return [...values, value];
};

export default function FormProfileDialog({
  open,
  formType,
  onClose,
  selectedProfile,
  toggleAtivo,
}) {
  const classes = useStyles();
  const snackbar = useSnackbar();

  const [submitting, setSubmitting] = useState(false);
  const [menus, setMenus] = useState(null);
  const [notificacoes, setNotificacoes] = useState(null);
  const [initialNotificationLinked, setInitialNotificationLinked] = useState(
    [],
  );
  const [notificacoesVinculadas, setNotificacoesVinculadas] = useState([]);
  const [tabVinculacao, setTabVinculacao] = useState("1");
  const [vinculados, setVinculados] = useState([]);
  // const [menusVinculados, setMenusVinculados] = useState(selectedProfile?.Menus || []);

  const deleteProfile = async (idPerfil) => {
    setSubmitting(true);

    await Api.deleteParams(
      "delete-profile",
      "adminportal",
      "?idPerfil=" + idPerfil.toString(),
      true,
    )
      .then((res) => {
        if (res.Success) {
          snackbar.showMessage(`Perfil excluído com sucesso!`, {
            severity: "success",
          });
          setSubmitting(false);
          handleClose({ IdPerfil: idPerfil });
        } else {
          snackbar.showMessage("Ocorreu um erro ao deletar o perfil.", {
            severity: "error",
          });
          setSubmitting(false);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setSubmitting(false);
      });
  };

  const profileId = selectedProfile?.IdPerfil ?? 0;

  const updateProfileLinks = async (idPerfil, updatedProfileRef) => {
    let updatedProfile = updatedProfileRef;

    await Api.post(
      "profile-menus-update",
      "adminportal",
      {
        idPerfil,
        idsMenus: vinculados.map((item) => item).join(","),
      },
      true,
    )
      .then((res) => {
        if (res.Success) {
          updatedProfile = res.Result;
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setSubmitting(false);
      });

    await Api.put(
      "notification-topic-update",
      "notification",
      {
        IdPerfil: idPerfil.toString(),
        IdsTopicos:
          notificacoesVinculadas.map((item) => item.IdTopico).join(",") || "",
      },
      true,
    ).catch((error) => {
      snackbar.showMessage(error, {
        severity: "error",
      });
      setSubmitting(false);
    });

    return updatedProfile;
  };

  const submit = async (values) => {
    const { nome, ativo, canais, tiposPessoa } = values;
    let updatedProfile = {};
    const canaisParam = canais.join(",");
    const tiposPessoaParam = tiposPessoa.join(",");

    setSubmitting(true);

    if (formType === "active") {
      updatedProfile = { ...selectedProfile, Ativo: !selectedProfile.Ativo };

      await toggleAtivo(updatedProfile);

      return onClose(updatedProfile);
    }

    if (formType === "delete") {
      return deleteProfile(selectedProfile?.IdPerfil);
    }

    if (formType === "edit") {
      updatedProfile = await updateProfileLinks(
        selectedProfile.IdPerfil,
        updatedProfile,
      );
    }

    return await Api.postParams(
      formType === "edit" ? "update-profile" : "create-profile",
      "adminportal",
      "?nome=" +
        nome +
        "&ativo=" +
        ativo.toString() +
        "&canais=" +
        encodeURIComponent(canaisParam) +
        "&tiposPessoa=" +
        encodeURIComponent(tiposPessoaParam) +
        (selectedProfile?.IdPerfil
          ? "&idPerfil=" + selectedProfile.IdPerfil.toString()
          : ""),
      true,
    )
      .then(async (res) => {
        if (res.Success) {
          if (formType === "create") {
            updatedProfile = await updateProfileLinks(
              res.Result.IdPerfil,
              res.Result,
            );
          }

          snackbar.showMessage(
            `Perfil ${
              formType === "edit" ? "atualizado" : "criado"
            } com sucesso!`,
            {
              severity: "success",
            },
          );
          setSubmitting(false);
          handleClose({ ...updatedProfile, ...res.Result });
        } else {
          snackbar.showMessage(
            `Ocorreu um erro ao ${
              formType === "edit" ? "atualizar" : "criar"
            } o perfil. Verifique os parâmetros informados.`,
            {
              severity: "error",
            },
          );
          setSubmitting(false);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setSubmitting(false);
      });
  };

  const initialCanais = selectedProfile?.Canais || [];
  const initialTiposPessoa = selectedProfile?.TiposPessoa || [];

  const formik = useFormik({
    initialValues: {
      nome: selectedProfile?.Nome || "",
      ativo: selectedProfile?.Ativo ?? true,
      canais: initialCanais,
      tiposPessoa: initialTiposPessoa,
    },
    onSubmit: submit,
  });

  const {
    values,
    handleChange,
    handleSubmit,
    dirty,
    resetForm,
    setFieldValue,
  } = formik;

  const handleClose = useCallback(
    (updatedProfile) => {
      resetForm();
      onClose(updatedProfile);
    },
    [onClose, resetForm],
  );

  const fetchNotificacoes = useCallback(() => {
    if (profileId === 0) return;

    return Api.get(
      `notification-topic-list?idPerfil=${profileId}`,
      "notification",
      "",
      true,
    )
      .then(({ Success, Result }) => {
        if (Success) {
          if (
            !Result?.ListTopicosNaoVinculados?.length &&
            !Result?.ListTopicosVinculados?.length
          ) {
            snackbar.showMessage("Não há Notificações cadastradas.", {
              severity: "info",
            });
          } else {
            setNotificacoes(Result?.ListTopicosNaoVinculados || []);
            setNotificacoesVinculadas(Result?.ListTopicosVinculados || []);
            setInitialNotificationLinked(Result?.ListTopicosVinculados || []);
          }
        }
      })
      .catch((error) => {
        setSubmitting(false);
        snackbar.showMessage(error, {
          severity: "error",
        });
      });
  }, [profileId, snackbar]);

  const fetchMenus = useCallback(() => {
    Api.get(`list-menu-profile?idPerfil=${profileId}`, "adminportal", "", true)
      .then(({ Success, Result }) => {
        if (Success) {
          if (Result.length === 0) {
            snackbar.showMessage("Não há Menus cadastrados.", {
              severity: "info",
            });
          } else {
            setMenus(Result);
          }
          setSubmitting(false);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
      });
  }, [snackbar, profileId]);

  const handleTabChange = (e, newTab) => {
    if (newTab !== tabVinculacao) {
      let naoVinculados = [];

      switch (newTab) {
        case "2":
          naoVinculados = filtraNaoVinculados(
            notificacoes,
            notificacoesVinculadas,
            "IdTopico",
          );
          setNotificacoes(naoVinculados);
          break;
        default:
          break;
      }

      setTabVinculacao(newTab);
    }
  };

  useEffect(() => {
    if (formType === "edit" || formType === "create") {
      setSubmitting(true);
      Promise.all([
        !menus || menus.length === 0 ? fetchMenus() : null,
        !notificacoes || notificacoes.length === 0 ? fetchNotificacoes() : null,
      ]).then(() => {
        setSubmitting(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        maxWidth={"xl"}
      >
        <PerfectScrollbar>
          <DialogTitle>
            <span>
              <Typography id="alert-dialog-title" variant="h3" component="h3">
                {`${
                  formType === "edit"
                    ? "Editar"
                    : formType === "delete"
                      ? "Excluir"
                      : formType === "active"
                        ? selectedProfile.Ativo
                          ? "Inativar"
                          : "Ativar"
                        : "Criar"
                } Perfil`}
              </Typography>
            </span>
          </DialogTitle>
          <PerfectScrollbar>
            <DialogContent style={{ padding: "1rem 1.5rem 0" }}>
              {formType === "delete" ? (
                <>
                  <Typography variant="h4" style={{ marginBottom: "1rem" }}>
                    Confirmar exclusão do Perfil?
                  </Typography>
                  {selectedProfile.NrUsuarios > 0 && (
                    <Alert
                      classes={{ icon: classes.icon, message: classes.message }}
                      severity="warning"
                    >
                      Existem {selectedProfile.NrUsuarios} usuários vinculados a
                      este perfil!
                    </Alert>
                  )}
                </>
              ) : formType === "active" ? (
                <>
                  <Typography variant="h4" style={{ marginBottom: "1rem" }}>
                    {`Confirmar ${
                      selectedProfile.Ativo ? "inativação" : "ativação"
                    } do Perfil?`}
                  </Typography>
                  {selectedProfile.NrUsuarios > 0 && selectedProfile.Ativo ? (
                    <Alert
                      classes={{ icon: classes.icon, message: classes.message }}
                      severity="warning"
                    >
                      Existem {selectedProfile.NrUsuarios} usuários vinculados a
                      este perfil!
                    </Alert>
                  ) : null}
                </>
              ) : (
                <>
                  <Grid item xs={12} style={{ marginBottom: "1rem" }}>
                    <FormGroup>
                      <FormLabel>Nome *</FormLabel>
                      <TextField
                        name="nome"
                        required
                        fullWidth
                        disabled={submitting}
                        value={values.nome}
                        variant="outlined"
                        onChange={handleChange}
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .toString()
                            .slice(0, 200);
                        }}
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} style={{ marginBottom: "1rem" }}>
                    <FormGroup>
                      <FormLabel>Canal *</FormLabel>
                      <Box display="flex" flexWrap="wrap">
                        {PROFILE_CANAL_OPTIONS.map((option) => (
                          <FormControlLabel
                            key={option.value}
                            control={
                              <Checkbox
                                checked={values.canais.includes(option.value)}
                                onChange={() =>
                                  setFieldValue(
                                    "canais",
                                    toggleArrayValue(
                                      values.canais,
                                      option.value,
                                    ),
                                  )
                                }
                                color="primary"
                                disabled={submitting}
                              />
                            }
                            label={option.label}
                          />
                        ))}
                      </Box>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} style={{ marginBottom: "1rem" }}>
                    <FormGroup>
                      <FormLabel>Tipo Pessoa *</FormLabel>
                      <Box display="flex" flexWrap="wrap">
                        {PROFILE_TIPO_PESSOA_OPTIONS.map((option) => (
                          <FormControlLabel
                            key={option.value}
                            control={
                              <Checkbox
                                checked={values.tiposPessoa.includes(
                                  option.value,
                                )}
                                onChange={() =>
                                  setFieldValue(
                                    "tiposPessoa",
                                    toggleArrayValue(
                                      values.tiposPessoa,
                                      option.value,
                                    ),
                                  )
                                }
                                color="primary"
                                disabled={submitting}
                              />
                            }
                            label={option.label}
                          />
                        ))}
                      </Box>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={values.ativo}
                          onChange={handleChange}
                          name="ativo"
                          color="primary"
                          disabled={submitting}
                        />
                      }
                      label={<FormLabel>Ativo</FormLabel>}
                    />
                  </Grid>
                  <Grid container>
                    <Grid item xs={12}>
                      <Divider style={{ width: "100%", margin: "1rem 0" }} />
                      <Typography variant="h4">Vínculos do Perfil</Typography>
                      <TabContext value={tabVinculacao}>
                        <Box
                          style={{
                            borderBottom: 1,
                            borderColor: "divider",
                          }}
                        >
                          <TabList
                            onChange={handleTabChange}
                            aria-label="Vínculos do perfil"
                          >
                            <Tab
                              label="Menus"
                              value="1"
                              icon={!menus ? <HourglassEmptyIcon /> : null}
                              disabled={submitting || !menus}
                            />
                            <Tab
                              label="Notificações"
                              value="2"
                              icon={
                                notificacoes === null ? (
                                  <HourglassEmptyIcon />
                                ) : null
                              }
                              disabled={submitting || notificacoes === null}
                            />
                          </TabList>
                        </Box>
                        <TabPanel value="1">
                          <TransferListProfile
                            loading={!menus}
                            initial={menus}
                            label="Menus disponíveis"
                            setVinculados={setVinculados}
                          />
                        </TabPanel>
                        <TabPanel value="2">
                          <TransferList
                            loading={notificacoes === null}
                            initialLeft={notificacoes}
                            initialRight={notificacoesVinculadas}
                            leftLabel="Notificações disponíveis"
                            rightLabel="Notificações vinculadas"
                            onRightChange={(value) =>
                              value &&
                              !UtilsFncs.ArrayEquals(
                                value,
                                notificacoesVinculadas,
                              ) &&
                              setNotificacoesVinculadas(value)
                            }
                            itemLabelKey="Topico"
                            itemIdKey="IdTopico"
                          />
                        </TabPanel>
                      </TabContext>
                    </Grid>
                  </Grid>
                </>
              )}
              {submitting && (
                <div style={{ marginTop: "1rem" }}>
                  <span>{`${
                    formType === "create"
                      ? "Criando"
                      : formType === "edit"
                        ? "Atualizando"
                        : formType === "active"
                          ? selectedProfile.Ativo
                            ? "Inativando"
                            : "Ativando"
                          : "Deletando"
                  } perfil...`}</span>
                  <LinearProgress />
                </div>
              )}
            </DialogContent>
          </PerfectScrollbar>
          <DialogActions>
            <Button component={Box} onClick={handleClose} disabled={submitting}>
              Cancelar
            </Button>
            {formType === "delete" ? (
              <Button
                color="default"
                variant="contained"
                type="submit"
                disabled={submitting}
              >
                Confirmar
              </Button>
            ) : formType === "active" ? (
              <Button
                color="default"
                variant="contained"
                type="submit"
                disabled={submitting}
                onClick={submit}
              >
                {selectedProfile.Ativo ? "Inativar" : "Ativar"}
              </Button>
            ) : (
              <Button
                color="default"
                variant="contained"
                type="submit"
                disabled={
                  submitting ||
                  MaskAndValid.isNullOrEmpty(values.nome) ||
                  values.canais.length === 0 ||
                  values.tiposPessoa.length === 0 ||
                  (checkNothingChanged(
                    selectedProfile,
                    vinculados,
                    notificacoesVinculadas,
                    initialNotificationLinked,
                    values.canais,
                    values.tiposPessoa,
                    initialCanais,
                    initialTiposPessoa,
                  ) &&
                    formType === "edit" &&
                    !dirty)
                }
                onClick={handleSubmit}
              >
                {formType === "edit" ? "Atualizar" : "Criar"}
              </Button>
            )}
          </DialogActions>
        </PerfectScrollbar>
      </Dialog>
    </>
  );
}
